import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';


export const addMaterialMasterTempData = async(data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/material-master-temp/create`, data);
        return await response.data;
    } catch (error) {
        console.log("addMaterialMasterTempData - error", error)
        return handleApiError(error)
    }
}

export const getMaterialMasterTempData = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/material-master-temp/`, data);
        return await response.data;
    } catch (error) {
        console.log("getMaterialMasterTempData - error", error)
        return handleApiError(error)
    }
}

export const getMaterialMasterTempPendingRequestData = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/material-master-temp/pending`, data);
        return await response.data;
    } catch (error) {
        console.log("getMaterialMasterTempData - error", error)
        return handleApiError(error)
    }
}

export const updatedMaterialMasterTemp = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/material-master-temp/update/${data.materialId}`, data)
        return await response.data;
    } catch (error) {
        console.log("updatedMaterialMasterTemp - error", error)
        return handleApiError(error)
    }
}

export const updateMaterialMasterTempPriorityStatus = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/material-master-temp/priority`, data)
        console.log("upt prio", response)
        return await response.data;
    } catch (error) {
        console.log("updateMaterialMasterTempPriorityStatus - error", error)
        return handleApiError(error)
    }
}

export const  getMaterialMasterTempItemByMaterialId = async (materialId) => {
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/material-master-temp/${materialId}`);
        const result = await res.data;
        return result
    } catch (error) {
        console.log("getMaterialMasterTempItemByMaterialId - error", error)
        return handleApiError(error)
    }
}

export const duplicateMaterialIdFromBuyerReqAndPO = async (materialId) => {
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/material-master-temp/duplicate-materialid-from-buyer-req-po/${materialId}`);
        const result = await res.data;
        return result
    } catch (error) {
        console.log("duplicateMaterialIdFromBuyerReqAndPO - error", error)
        return handleApiError(error)
    }
}

export const searchMaterialMasterTempRaw = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/material-master-temp/search`, data);
        return await response.data;
    } catch (error) {
        console.log("searchMaterialMasterTempRaw - error", error)
        return handleApiError(error)
    }
}

export const deleteMaterialMasterTempByMaterialId = async (materialId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/material-master-temp/delete/${materialId}`, data)
        return await response.data;
    } catch (error) {
        console.log("removeData - error", error)
        return handleApiError(error)
    }
}

export const materialIdExistsInOtherRequirement = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/material-master-temp/materialid-exists-in-other-requirement/${data.materialId}`, data)
        return await response.data;
    } catch (error) {
        console.log("materialIdExistsInOtherRequirement - error", error)
        return handleApiError(error)
    }
}

export const checkMaterialsAreInMaterialSpecs = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/material-master-temp/check-material-specs`, data)
        return await response.data;
    } catch (error) {
        console.log("checkMaterialsAreInMaterialSpecs - error", error)
        return handleApiError(error)
    }
}

export const updateAssigneeCentralUserIdAndPriorityStatus = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/material-master-temp/update-assignee-userid-and-priority`, data)
        console.log("updateAssigneeCentralUserIdAndPriorityStatus-respone", response)
        return await response.data;
    } catch (error) {
        console.log("updateAssigneeCentralUserIdAndPriorityStatus - error", error)
        return handleApiError(error)
    }
}

export const getProcessingMaterialImagesUsingParser = async (data) => {
    const headers = {
        ...axios.defaults.headers.common,
        "x-api-key": "e7d2bf40-2fb3-4f3d-96b4-10fe6d5f6c87"
    }
    try {
        // const response = await axios.post(`https://portal.procmart.com/api/core/material-master-temp/get-processed-image`, data, headers)
        const response = await axios.post(`${REACT_APP_API_URL}/material-master-temp/get-processed-image`, data)
        return await response.data;
    } catch (error) {
        console.log("getProcessingMaterialImagesUsingParser - error", error)
        return handleApiError(error)
    }
}